import { forEach } from 'lodash';
import { isMoment, Moment } from 'moment';

type filterType = Array<Moment> | string | Moment | undefined;

const formatFilters = (filters: Record<string, filterType>) => {
  const formattedFilters: Record<string, any> = {};
  forEach(filters, (filterValue: filterType, filterName: string) => {
    switch (true) {
      case filterName === 'date':
        formattedFilters.createdFrom = (filterValue as Array<Moment>)?.[0]?.format();
        formattedFilters.createdTo = (filterValue as Array<Moment>)?.[1]?.format();
        break;

      case isMoment(filterValue):
        formattedFilters[filterName] = (filterValue as Moment)?.format();
        break;

      default:
        formattedFilters[filterName] = filterValue;
        break;
    }
  });
  return formattedFilters;
};

export default formatFilters;
